<template>
  <d2-container>
   <div class="supports">
      <div class="supportcontent">
        <div class="supportcontcard">
          <h4 class="supportcontcardTitle">提交成功</h4>
          <div class="supportcontcardMsg">
            <p>您的表单已提交成功，</p>
            <p>稍后会有工作人员第一时间与您电话联系。</p>
            <p>如果您现在就需要帮助，可立即拨打 <span>17858952922</span> 与我们联系!</p>
          </div>

          </div>
      </div>

      <base-bottom></base-bottom>
   </div>
  </d2-container>
</template>

<script>
import baseBottom from '../components/base-bottom'
import {addNewList} from "@/api/data.js"

export default {
  name: 'hosting',
  components: {
    baseBottom
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>

.supports{
  min-height: 200vh;
}
.supportcontent{
  /* background: url(/image/portalimg/support/card.png) no-repeat center center; */
  width: 1560px;
  margin: 50px auto 200px;
}
.supportcontcard{
  width: 800px;
  margin: 0 auto;
}
.supportcontcardMsg {
  font-size: 18px;
  color: #333;
  letter-spacing: 2px;
  text-align: left;
  font-weight: 400;
  padding: 0 58px 40px;
  margin: 0;
}
.supportcontcardMsg p span{
  color: #409EFF;
}
.supportcontcardTitle{
  font-size: 38px;
  color: #000000;
  letter-spacing: 4px;
  text-align: left;
  font-weight: 400;
  padding: 80px 58px 40px;
  margin: 0;
}

.el-form-item{
  margin-bottom: 30px !important;
}

::v-deep .el-form-item__label {
    font-size: 18px !important; /* 根据需要调整 */
    padding-right: 50px;
    line-height: 52px;
}

::v-deep .el-input__inner {
    height: 50px; /* 调整高度 */
    line-height: 50px; /* 保证文本垂直居中 */
    font-size: 14px; /* 调整字体大小 */
}
::v-deep .item__error{
  top:58px;
}
.login-btn span{
  color:#fff;
}
.el-textarea{
  margin-top: 0px !important;
}
</style>
